import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { useBatchRemoveOperations } from 'hooks/batchOperations';

const PERSONAL_OVERVIEW_CONFIG = {
  key: 'removePersonalKeyObjectives',
  invalidate: 'personalOverview',
  resource: SPARK_RESOURCE_TYPES.PERSONAL_OVERVIEW_KEY_OBJECTIVES,
  attributeKey: 'personalOverviewID',
};
const COMPANY_OVERVIEW_CONFIG = {
  key: 'removeCompanyOverviewKeyObjectives',
  invalidate: 'companyOverview',
  resource: SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_KEY_OBJECTIVES,
  attributeKey: 'companyOverviewID',
};

type mutationVariables = {
  keyObjectiveIDs: string[];
};

export function useBatchRemoveKeyObjectives(
  type:
    | typeof SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_KEY_OBJECTIVES
    | typeof SPARK_RESOURCE_TYPES.PERSONAL_OVERVIEW_KEY_OBJECTIVES,
  overviewID: string | undefined
) {
  const config =
    type === SPARK_RESOURCE_TYPES.COMPANY_OVERVIEW_KEY_OBJECTIVES
      ? COMPANY_OVERVIEW_CONFIG
      : PERSONAL_OVERVIEW_CONFIG;

  const queryClient = useQueryClient();
  const { mutateAsync: removeBatchOperation } = useBatchRemoveOperations();

  const removeCompanyOverviewKeyObjective = (
    mutationsVariables: mutationVariables
  ) => {
    const categoryArray = mutationsVariables.keyObjectiveIDs.map(
      (keyObjectiveID) => ({
        type: config.resource,
        id: keyObjectiveID,
      })
    );

    return removeBatchOperation(categoryArray);
  };

  return useMutation(config.key, removeCompanyOverviewKeyObjective, {
    onSuccess: async () => {
      queryClient.invalidateQueries([config.invalidate, overviewID]);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to key objectives: ${error.message}`);
      }
    },
  });
}
